import Vue from 'vue';
import Component from 'vue-class-component';
import SketchfabFrame from '../sketchfabFrame/SketchfabFrame.vue';
import { Prop, Inject } from 'vue-property-decorator';
import { ConfiguratorService, ConfiguratorServiceSettings, HideObjectsCommand, FilterOperators } from '../../../services/sketchfab/index';
import { Store } from '@/store';
import { ServiceIdentifiers } from '@/services';
import { ComponentContainer } from '@/services/container';

import * as _ from 'lodash';
import ProductSelector from '@/components/productSelector/ProductSelector';
import { ProductDefinition, AnimationDefinition } from '@/models/configuratorx/configuratorSchema';
import Toggle from '@/components/parts/Toggle';

import PartsColor from '@/components/partsColor/PartsColor';
import { parseEnum } from '@/utils';


@Component({
  components: {
    toggle: Toggle,
    partsColor: PartsColor,
  },
})
export default class CosmoKolcaksiz extends Vue {
  private _configuratorService: ConfiguratorService = undefined;


  @Inject()
  private _container: ComponentContainer;



  product: ProductDefinition;



  defHideObjects = [
    '_yyy',
  ];

  defShowObjects = [
    'cosmo_kolcaksiz_sirt_yyy',
    'cosmo_kolcaksiz_sirt_pedal_yyy',
    'cosmo_kolcaksiz_tansiyon_yyy',
    'cosmo_kolcaksiz_yyy',
    'cosmo_kolcaksiz_ayak_yyy',
    'cosmo_kolcaksiz_pedal_yyy',
  ];



  availableAnimations: AnimationDefinition[] = [];


  async created() {
    this.product = Store.getProductById('cosmo_kolcaksiz');
    this.product.partsPalettes = _.orderBy(this.product.partsPalettes, ['order'], ['asc']);
    this.setAnimations(true);


    this._configuratorService = this._container.get<ConfiguratorService>(ServiceIdentifiers.ConfiguratorService);
    await this._configuratorService.hideObjects({ objects: this.defHideObjects, operator: FilterOperators.Contains });
    await this._configuratorService.showObjects({ objects: this.defShowObjects, operator: FilterOperators.Contains });



    if (Store.state.selection) {
      Store.state.selection.parts.forEach((element) => {
        this.colorChanged(element.color, element.palette, element.id);
      });
    } else {
      await this.applyDefaultSelection();
    }

  }


  availableAnimationsChanged() {

    this.$emit('availableAnimationsChanged', this.availableAnimations);
  }



  mounted() {
    // this.configuratorService = Store.state.configuratorService;

  }

  async applyDefaultSelection() {
    const selection = new BanzaiSelection();
    selection.parts = [];

    this.product.defaults.parts.forEach((element) => {
      this.colorChanged(element.color, element.palette, element.id);
      const part = new PartSelection();
      part.id = element.id;
      part.color = element.color;
      part.palette = element.palette;
      part.name = element.name;
      selection.parts.push(part);
    });

    Store.state.selection = selection;

  }

  setAnimations(isKizakli: boolean) {
    let animations = [];


    if (!isKizakli) {
      this.product.animations.forEach((element) => {
        if (!(element.animationName === 'a3' || element.animationName === 'a2')) {
          animations.push(element);
        }
      });
    } else {
      animations = this.product.animations as any[];

    }

    this.availableAnimations = animations;
    this.availableAnimationsChanged();
  }

  async colorChanged(color: any, palette: any, part: any) {

    const getPart = this.product.partsPalettes.find(x => x.part === part);
    const getPalettes = Store.state.configuratorConfig.definitions.palettes.find(x => x.id === palette);
    const getColor = getPalettes.colors.find(col => col.name === color);
    await this._configuratorService.changeAlbedoPBR({
      materials: getPart.materials,
      texture: getColor.texture,
    });
    console.log(getColor.texture);
    await this._configuratorService.changeBumpMap({
      materials: getPart.materials,
      texture: getColor.texture,
    });

    await this._configuratorService.changeOpacity({
      enable: false,
      materials: getPart.materials,
    });

    Store.state.selection.parts.find(x => x.id === part).palette = palette;
    Store.state.selection.parts.find(x => x.id === part).color = color;
  }


}



export class BanzaiSelection {
  parts: PartSelection[];
}
export class PartSelection {
  id: string;
  palette: string;
  name: string;
  color: string;

}



// WEBPACK FOOTER //
// ./src/components/families/cosmo/CosmoKolcaksiz.ts